import { render } from "./PackagesManagerSettingsList.vue?vue&type=template&id=90f5b02a&scoped=true"
import script from "./PackagesManagerSettingsList.vue?vue&type=script&lang=js"
export * from "./PackagesManagerSettingsList.vue?vue&type=script&lang=js"

import "./PackagesManagerSettingsList.vue?vue&type=style&index=0&id=90f5b02a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90f5b02a"]])

export default __exports__